import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { table } from 'console';
import { Subject } from 'rxjs';
import { LocationSearch } from '../models/locations';
import { MerchantSearch } from '../models/merchant';
import { MerchantProductSearch } from '../models/merchant-product';
import { ProductSearch } from '../models/product';
import { ProductOfferSearch } from '../models/productOffer';
 import { NzTableData } from '../utilities/nz-table.adapter';
import * as urls from '../utilities/urls';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  
  public refreshMerchantProduct: Subject<boolean> = new Subject<boolean>();
  constructor(private httpClient: HttpClient, private router: Router) { }
//To get Product Lists
  getMerchantLocationProductlist(tableData: NzTableData<ProductSearch, any>){
    const value={
    merchantId:tableData.search.merchantId,
    productName: tableData.search.productName,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex,
    locationId:tableData.search.locationId,
    isAvailable:tableData.search.isAvailable,
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    includeOffer: true
    }
      return this.httpClient.post(urls.ProductUrls.locationProductlist,value);
  }
  //To get Product Lists
  getMerchantProductlist(tableData: NzTableData<ProductSearch, any>){
    const value={
    locationId:tableData.search.locationId,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex,
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    }
    return this.httpClient.post(urls.ProductUrls.locationBasedProductlist,value);
  }
  getLocationBasedProductList(tableData:NzTableData<ProductSearch,any>){
    const value ={
      pageSize: tableData.pageSize,
      name: tableData.search.productName,
      pageIndex: tableData.pageIndex,
      locationId:tableData.search.locationId,
      linkedProduct:false,
      merchantId:+tableData.search.merchantId
    } 
       return this.httpClient.post(urls.ProductUrls.locationBasedProductlist,value)
  }
  // For all products
  clearSearchFields(tableData: NzTableData<ProductSearch, any>, value) {
     if (value === 'productName') {
     return tableData.search.productName = '';
     }
  }
  createProduct(value){
   return this.httpClient.post(urls.ProductUrls.create,value)
  }
  editProduct(id,value){
     return this.httpClient.patch(urls.ProductUrls.edit + id ,value)
  }
  deleteProduct(value){
    return this.httpClient.delete(urls.ProductUrls.delete+value.id)
  }
  profileImageUpload(value){
    return this.httpClient.post(urls.ProductUrls.upload,value);
  }
  deleteImage(value){
    return this.httpClient.delete(urls.ProductUrls.deleteImage+value.id+'/'+'productImages'+'/'+value.originFileObj.name)
  }
  getImageList(value){
    return this.httpClient.post(urls.ProductUrls.listImages,value)
  }
  getBlobImage(value){
    return this.httpClient.get(urls.ProductUrls.downloadImage+'/'+value.imageName+'/productImages',{ responseType: 'blob' as 'json'})
  }
  createMerchantLocationProduct(value){
    return this.httpClient.post(urls.ProductUrls.createMerchantLocationProduct,value);
  }
  // Edit MerchantProductLocation
editMerchantProductLocation(id, value) {
  return this.httpClient.patch(urls.ProductUrls.merchantLocationProductsUpdate + '/' + id, value);
}
// delete MerchantProductLocation
deleteMerchantProductLocation(id) {
  return this.httpClient.delete(urls.ProductUrls.deleteMerchantProductLocation + '/' + id);
}
// Merchant Product Assign Location
merchantProductAssignLocation(value) {
    return this.httpClient.post(urls.ProductUrls.createLocationProduct, value);
}
getProductOffersList(tableData: NzTableData<ProductOfferSearch, any>){
  const value={
   pageSize:tableData.pageSize,
   pageIndex:tableData.pageIndex,
    mlpId:tableData.search.mlpId,
   appCode:tableData.search.appCode,
   startDate:tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate:'',
   endDate:tableData.search.createdDate.endDate? tableData.search.createdDate.endDate : '',
   offerPrice: tableData.search.offerPrice,
   status:tableData.search.status
  }
  return this.httpClient.post(urls.ProductUrls.merchantOffersList,value);
}
saveOffer(value){
 return this.httpClient.post(urls.ProductUrls.saveOffers,value);
}
editOffer(value,id){
  return this.httpClient.patch(urls.ProductUrls.updateOffers+id,value);
}
deleteOffer(id){
  return this.httpClient.delete(urls.ProductUrls.deleteOffers+id);
}
// Merchant Product List with Page Limit
 getMerchantProductWithLimit(value) {
  return this.httpClient.post(urls.ProductUrls.productList, value);
}
 // Clear search
 clearProductSearchFields(tableData: NzTableData<MerchantProductSearch, any>, value) {
  if (value === 'name') {
      return tableData.search.name = '';
  }
  if (value === 'merchantName') {
      return tableData.search.merchantName = '';
  }
  if (value === 'appCode') {
      return tableData.search.appCode = '';
  }
  if (value === 'startDate') {
      return tableData.search.startDate = '';
  }
  if (value === 'endDate') {
      return tableData.search.endDate = '';
  }
}
  // Download report as Excel
  downloadReport(value) {
    return this.httpClient.post(urls.MerchantUrls.merchant + urls.MerchantUrls.list, value);
  }
 //sync products 
 syncProducts() {
  return this.httpClient.get(urls.ProductUrls.syncProductList);
}
 //get Ayopop balance 
 getAyopopBalance() {
  return this.httpClient.get(urls.ProductUrls.checkAyopopBalance);
}
 //Download Merchant Products.
 downloadMerchantProductReport(value) {
   return this.httpClient.post(urls.ProductUrls.productList, value);
 }
    // For Create
    createMerchantProduct(value) {
      const args = {
          merchantId: value.merchantId,
          name: value.name,
          code: value.code,
          price: value.price,
          description: value.description,
          additionalNotes: value.additionalNotes,
          appCode: value.appCode,
         // categoryId:value.category
      }
       return this.httpClient.post(urls.ProductUrls.productCreate, args);
  }
  createMerchantProductCategory(value){
    return this.httpClient.post(urls.ProductUrls.linkMerchantProductToCategory,value);
   }
   updateMerchantProductCategory(value){
    return this.httpClient.patch(urls.ProductUrls.updatelinkMerchantProductToCategory,value);
   }
   deleteMerchantProductCategory(value,Id){
    return this.httpClient.delete(urls.ProductUrls.deletelinkMerchantProductToCategory+Id,value)
   }
   getCategoryList(value){
    return this.httpClient.post(urls.ProductUrls.categoryList,value);
   }
 // For Update
 editMerchantProduct(id, value) {
  return this.httpClient.patch(urls.ProductUrls.productUpdate + id, value);
}
// For Delete
deleteMerchantProduct(id) {
  return this.httpClient.delete(urls.ProductUrls.productDelete + id);
}
    // For Delete Image 
deleteMerchantProductImage(value) {
 return this.httpClient.delete(urls.ProductUrls.deleteImage + value.id + '/' + 'productImages' + '/' + value.originFileObj.name);
}
  // For List with Page Limit
  getMerchantsWithLimit(tableData: NzTableData<MerchantSearch, any>) {
    const value = {
      startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
      endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
      id: tableData.search.id ? tableData.search.id : '',
      name: tableData.search.name ? tableData.search.name : '',
      companyName: tableData.search.companyName ? tableData.search.companyName : '',
      merchantType: tableData.search.merchantType ? tableData.search.merchantType : '',
      isRemittanceMerchant: tableData.search.isRemittanceMerchant,
      code: tableData.search.code ? tableData.search.code : '',
      mId: tableData.search.mId ? tableData.search.mId : '',
      status: tableData.search.status,
      category: tableData.search.category,
      appCode: tableData.search.appCode,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex,
    };
    return this.httpClient.post(urls.MerchantUrls.merchant + urls.MerchantUrls.list, value);
  }
// For List
assignMerchantProductLocationList(tableData: NzTableData<LocationSearch, any>) {
  const value = {
            productId: tableData.search.productId ? tableData.search.productId : '',
            merchantId: tableData.search.merchant ? tableData.search.merchant : '',
            appCode: tableData.search.appCode ? tableData.search.appCode : '',
            pageSize: tableData.pageSize,
            pageIndex: tableData.pageIndex
        };
  return this.httpClient.post(urls.ProductUrls.merchantLocationProductsList, value);
}
// For List
getLocationsNonLinkedProductWithLimit(tableData: NzTableData<LocationSearch, any>) {
  const value = {
            merchantId: tableData.search.merchant ? tableData.search.merchant : '',
            productId:tableData.search.productId ? tableData.search.productId:'',
            //linkedProduct:'',
            pageSize: tableData.pageSize,
            pageIndex: tableData.pageIndex
        };
    return this.httpClient.post(urls.ProductUrls.productNtLinkedLocation,value);
}
refreshMerchantProductList(event) {
  return this.refreshMerchantProduct.next(true);
}
    // thumbnail  image

    thumbnailUpload(value) {
      return this.httpClient.post(urls.ProductUrls.thumbnailUpload, value);
  }
  thumbnailDelete(id, image) {
      return this.httpClient.delete<any>(urls.ProductUrls.thumbnailDelete + id +'/thumbnail/'+image);
  }

}
